import { useTranslation } from "react-i18next";

const CtaBanner = () => {
  const { i18n } = useTranslation();
  const isEs = i18n.language === "es";

  return (
    <section className="relative py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=clean%20modern%20luxury%20home%20exterior%20beautiful%20Florida%20residential%20house%20lush%20green%20lawn%20bright%20sunny%20day%20blue%20sky%20professional%20photography%20wide%20angle&width=1920&height=700&seq=cta_bg1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark/90 via-brand-dark/75 to-brand-dark/50"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          {/* Label */}
          <div className="inline-flex items-center gap-2 bg-brand-green/20 border border-brand-green/40 text-green-300 px-4 py-1.5 rounded-full text-xs font-body tracking-widest uppercase mb-6">
            <i className="ri-phone-line"></i>
            {isEs ? "Respuesta Rápida" : "Fast Response"}
          </div>

          <h2 className="font-heading font-black text-white text-4xl md:text-5xl lg:text-6xl leading-tight mb-5">
            {isEs ? "¿Listo para un\n" : "Ready for a\n"}
            <span className="text-brand-green">{isEs ? "Hogar Impecable?" : "Spotless Home?"}</span>
          </h2>

          <p className="font-body text-white/70 text-base md:text-lg leading-relaxed mb-10 max-w-lg">
            {isEs
              ? "Contáctanos hoy y recibe tu cotización gratis. Respondemos en minutos por WhatsApp o teléfono."
              : "Contact us today and get your free quote. We respond in minutes via WhatsApp or phone."}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+15612626118"
              className="flex items-center justify-center gap-2.5 bg-white text-brand-dark hover:bg-gray-100 px-8 py-4 rounded-full font-heading font-bold text-sm transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-brand-green text-lg"></i>
              (561) 262-6118
            </a>
            <a
              href="https://wa.me/15612626118"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2.5 bg-brand-green hover:bg-brand-green-dark text-white px-8 py-4 rounded-full font-heading font-bold text-sm transition-all cursor-pointer whitespace-nowrap shadow-lg shadow-brand-green/30"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              {isEs ? "Enviar WhatsApp" : "Send WhatsApp"}
            </a>
          </div>

          {/* Trust note */}
          <p className="font-body text-white/40 text-xs mt-6 flex items-center gap-2">
            <i className="ri-shield-check-line text-brand-green"></i>
            {isEs
              ? "Sin compromisos · Cotización 100% gratis · Respuesta en minutos"
              : "No commitment · 100% free quote · Response in minutes"}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
